<div class="site-visit__block">
  <div *ngIf="!dialogMode" class="site-visit__header">
    <h2>Schedule Site Visit</h2>
    <button
      class="submit-button"
      [disabled]="
        (!siteVisitDate1 || !siteVisitSlot1) &&
        (!siteVisitDate2 || !siteVisitSlot2) &&
        (!siteVisitDate3 || !siteVisitSlot3)
      "
      (click)="toggleSendModal()"
    >
      {{
        proposal?.siteVisit1 || proposal?.siteVisit2 || proposal?.siteVisit2
          ? "Update"
          : "Schedule"
      }}
    </button>
  </div>
  <div class="site-visit__block__container">
    <div class="site-visit__block__description">
      Please provide three preferred dates for your site visit and indicate
      whether you'd prefer a morning slot (8:00 AM - 12:00 PM) or an afternoon
      slot (1:00 PM - 5:00 PM). Providing multiple options helps us better
      accommodate your schedule.
    </div>
    <div class="site-visit__block__datepicker_container">
      <div class="site-visit__block__datepicker-grid">
        <div class="site-visit__block__datepicker">
          <label class="site-visit-label"> 1st Preferred Date: </label>
          <mat-form-field
            appearance="outline"
            [ngStyle]="{
              'background-color': 'transparent'
            }"
          >
            <input
              matInput
              [matDatepicker]="siteVisit1"
              [(ngModel)]="siteVisitDate1"
              (ngModelChange)="saveSiteVisitDate(1, $event)"
              [min]="minDate"
              [max]="maxDate"
              readonly
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="siteVisit1"
            ></mat-datepicker-toggle>
            <mat-datepicker #siteVisit1 />
          </mat-form-field>
        </div>
        <div class="site-visit__block__dateslot">
          <button
            [ngClass]="
              siteVisitSlot1 === 'AM' ? 'selected-button' : 'unselected-button'
            "
            (click)="saveSiteVisitSlot(1, 'AM')"
          >
            AM
          </button>
          <button
            [ngClass]="
              siteVisitSlot1 === 'PM' ? 'selected-button' : 'unselected-button'
            "
            (click)="saveSiteVisitSlot(1, 'PM')"
          >
            PM
          </button>
        </div>
        <div class="site-visit__block__datepicker">
          <label class="site-visit-label">2nd Preferred Date:</label>
          <mat-form-field
            appearance="outline"
            [ngStyle]="{
              'background-color': 'transparent'
            }"
          >
            <input
              matInput
              [matDatepicker]="siteVisit2"
              [(ngModel)]="siteVisitDate2"
              (ngModelChange)="saveSiteVisitDate(2, $event)"
              [min]="minDate"
              [max]="maxDate"
              readonly
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="siteVisit2"
            ></mat-datepicker-toggle>
            <mat-datepicker #siteVisit2 />
          </mat-form-field>
        </div>
        <div class="site-visit__block__dateslot">
          <button
            [ngClass]="
              siteVisitSlot2 === 'AM' ? 'selected-button' : 'unselected-button'
            "
            (click)="saveSiteVisitSlot(2, 'AM')"
          >
            AM
          </button>
          <button
            [ngClass]="
              siteVisitSlot2 === 'PM' ? 'selected-button' : 'unselected-button'
            "
            (click)="saveSiteVisitSlot(2, 'PM')"
          >
            PM
          </button>
        </div>
        <div class="site-visit__block__datepicker">
          <label class="site-visit-label"> 3rd Preferred Date: </label>
          <mat-form-field
            appearance="outline"
            [ngStyle]="{
              'background-color': 'transparent'
            }"
          >
            <input
              matInput
              [matDatepicker]="siteVisit3"
              [(ngModel)]="siteVisitDate3"
              (ngModelChange)="saveSiteVisitDate(3, $event)"
              [min]="minDate"
              [max]="maxDate"
              readonly
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="siteVisit3"
            ></mat-datepicker-toggle>
            <mat-datepicker #siteVisit3 />
          </mat-form-field>
        </div>
        <div class="site-visit__block__dateslot">
          <button
            [ngClass]="
              siteVisitSlot3 === 'AM' ? 'selected-button' : 'unselected-button'
            "
            (click)="saveSiteVisitSlot(3, 'AM')"
          >
            AM
          </button>
          <button
            [ngClass]="
              siteVisitSlot3 === 'PM' ? 'selected-button' : 'unselected-button'
            "
            (click)="saveSiteVisitSlot(3, 'PM')"
          >
            PM
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<site-visit-send-dialog
  [active]="sendSiteVisitDatesActive"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  (submitDates)="submitSiteVisitDates()"
  (modalClosed)="toggleSendModal()"
/>

<site-visit-confirmation-dialog
  [active]="siteVisitConfirmationActive"
  (modalClose)="toggleConfirmationModal()"
/>
